import * as types from './types';

export const getSingleProject = (payload) => {
  return {
    type: types.GET_SINGLE_PROJECT,
    payload,
  };
};

export const getSingleProjectSuccess = (payload) => {
  return {
    type: types.GET_SINGLE_PROJECT_SUCCESS,
    payload,
  };
};

export const getSingleProjectFail = (payload) => {
  return {
    type: types.GET_SINGLE_PROJECT_FAIL,
    payload,
  };
};
